import React from 'react';
import ReactDOM from 'react-dom/client';
// Токены дизайн-системы — раньше index.css: он объявляет старые имена как алиасы на них
import './styles/tokens.css';
import './index.css';
import './mobile.css';
import './tsd.css';
import App from './App';
import { applyTsdMode } from './hooks/useTsd';

// Терминал сбора данных: компактная вёрстка включается до первого рендера,
// иначе экран успевает моргнуть десктопной раскладкой.
applyTsdMode();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
